import {ChangeEvent, FC, useEffect, useRef} from "react";
import {AdminPageCard} from "./AdminPageCard";
import {useAdminEventConfigurator, useAdminNewsConfigurator} from "../../hooks";
import {NewsFormComponent} from "../form-components-latest-news";
import {KCTEventDto} from "../../types/contracts";
import {useEventsContext} from "../../providers/EventsProvider";

export const AdminNewsConfigurator: FC = () => {
  const {fetchedNews, handleSubmit, handleNewsChange, removeNews, addNews} = useAdminNewsConfigurator();
  const {loadSpecificEvent} = useAdminEventConfigurator();
  const hasAutoSelected = useRef(false);

  const {
    events,
    selectedEventId,
    setSelectedEventId
  } = useEventsContext()

  useEffect(() => {
    if (
      !hasAutoSelected.current && events && events.length > 0 && selectedEventId
    ) {
      loadSpecificEvent(selectedEventId);
      hasAutoSelected.current = true;
    }
  }, [loadSpecificEvent]);

  const onSelect = (id: string) => {
    setSelectedEventId(id);
    if (id !== "") {
      loadSpecificEvent(id);
    }
  };

  return (
    <AdminPageCard title="Konfigurace aktualit" className="max-w-3xl">
      <form onSubmit={handleSubmit}>
        {/* Load Existing Events */}
        <div className="mb-6">
          <label className="block mb-2 font-semibold" htmlFor="existing-events">
            Načtené existující události
          </label>
          <select
            id="existing-events"
            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
              onSelect(e.target.value)
            }
            className="w-full p-2 border border-gray-300 rounded-md"
            // defaultValue=""
            value={selectedEventId || ""}
          >
            <option value="">Vyberte událost pro úpravu</option>
            {events && events.map((evt: KCTEventDto) => (
              <option key={evt.id} value={evt.id}>
                {evt.name}
              </option>
            ))}
          </select>
        </div>
        {/* News Section */}
        <NewsFormComponent
          news={fetchedNews}
          handleNewsChange={handleNewsChange}
          removeNews={removeNews}
          addNews={addNews}
        />
        <div className="sticky bottom-0 mt-6 pt-4 pb-4 bg-gradient-to-b from-white/0 via-white/95 to-white">
          <div className="flex justify-end">
            <button
              type="submit"
              className="px-6 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 min-w-[120px]"
            >
              Uložit
            </button>
          </div>
        </div>
      </form>
    </AdminPageCard>
  );
};
